<template>
  <v-dialog content-class="cart-dialog" v-model="dialog" @keydown.esc="close" persistent>
    <div class="d-container">
      <v-icon @click="close" class="d-close-button">mdi-close-circle</v-icon>
      <img v-if="backgroundSrc" :src="backgroundSrc" class="d-background" :style="backgroundStyle" />
      <div v-if="confirmResult" class="result-panel">
        <div v-html="cartMessage.text" class="result-message" :style="cartMessage.style"></div>
      </div>
      <div v-else class="review-panel">
        <div class="header">
          <div class="header-title">{{ $t("PAD.cart") }}</div>
        </div>
        <div class="ordered-items">
          <v-row class="ordered-item" v-for="(oi, index) in orderItems" :key="index">
            <v-col cols="2">
              <v-img v-if="oi.item && oi.item.imageUri" :src="oi.item.imageUri" class="item-image" />
            </v-col>
            <v-col cols="7" class="pa-6">
              <div class="item-descr">
                {{ getItemDescr(oi) }}
                <div v-if="getItemOptions(oi)" class="item-options">{{ getItemOptions(oi) }}</div>
              </div>

              <div v-if="$store.getters.orderItemExtended(oi) > 0" class="item-total">
                {{ $store.getters.orderItemExtended(oi) | currency }}
              </div>
            </v-col>
            <v-col cols="3" class="qty-col">
              <div class="qty-box">
                <v-icon class="order-qty-button" @click="updateOrderQty(oi, -1)">
                  mdi-minus
                </v-icon>
                <div class="qty-value">{{ oi.qty }}</div>
                <v-icon @click="updateOrderQty(oi, 1)">
                  mdi-plus
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="footer">
          <div>
            <v-btn color="primary" @click="confirm">{{ $t("PAD.confirm_order") }}</v-btn>
          </div>
        </div>
      </div>
    </div>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <InputDialog password ref="inputDialog"></InputDialog>
  </v-dialog>
</template>

<script>
import mApp from "@/modules/app";
import mDialog from "@/modules/dialog";
import mEmployee from "@/modules/employee";
import mUtils from "@/modules/utils";
import InputDialog from "@/dialogs/InputDialog";

export default {
  components: {
    InputDialog,
  },

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      refreshing: false,
      confirmResult: undefined,
    };
  },

  computed: {
    backgroundSrc() {
      let _backgroundSrc = undefined;
      let image = this.$store.getters.padPopupSchema?.background?.image;
      if (image && (image.fileSize > 0 || image.altUrl)) _backgroundSrc = image.downloadPath;

      return _backgroundSrc;
    },

    backgroundStyle() {
      return this.$store.getters.padTableSchema?.background?.style;
    },

    cartMessage() {
      let text = "";
      if (this.confirmResult) {
        if (this.confirmResult.result == "ok") {
          return this.$store.getters.padMessage("cart");
        } else text = this.confirmResult.message;
      } else text = "Network error";

      return { text: `<h1>${text}</h1><br><br>Please try again later.`, style: this.$store.getters.padSetting.messages["cart"].style };
    },

    orderItems() {
      return this.$store.state.Order.order.orderItems.filter(x => x.qty > 0);
    },
  },

  methods: {
    open() {
      this.confirmResult = undefined;
      this.confirmPin = undefined;
      this.refreshing = false;
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      if (this.resolve) this.resolve(true);
      this.dialog = false;
    },

    async confirm() {
      if (this.orderItems.length == 0) return;
      if (!await mApp.checkNetworkStatus()) return;      

      let orderBy = undefined;
      if (this.$store.getters.padCheckoutAuthentication) {
        let inputRes = await this.$refs.inputDialog.open(this.$t("PAD.confirm_order_password"));
        if (inputRes) {
          if (this.$store.getters.padCheckoutAuthentication == "employee_pin") {
            let resp = await mEmployee.getEmployee({ pin: inputRes });
            let respResult = resp?.result;
            if (respResult == "ok") {
              orderBy = { code: resp.data.EmployeeCode, commonName: resp.data.EmployeeCommonName };
            } else {
              mDialog.messageDialog.open(this.$t("wrong_password"));
              return;
            }
          } else if (this.$store.getters.padCheckoutAuthentication == "system_pin") {
            let resp_verify = await mApp.verifyAppPin({ appPin: inputRes });
            if (resp_verify?.result != "ok") {
              mDialog.messageDialog.open(this.$t("wrong_password"));
              return;
            }
          }
        } else return;
      }

      this.refreshing = true;
      this.$store.commit("ORDER_ORDER_BY", orderBy);
      this.$store.commit("ORDER_ORDER_ITEMS", this.orderItems);

      let cachedOrder = mUtils.cloneObject(this.$store.state.Order.order);
      let resp = await this.sendOrderToServer(false);
      if (resp) {
        this.confirmResult = resp;
        if (resp.result == "ok") {
          let padOrder = this.$store.state.Pad.order;
          if (!padOrder) {
            let timeZone = {
              name: this.$store.getters.storeInfo.timeZone,
              utcOffset: this.$store.getters.storeInfo.timeZoneUtcOffset,
              utcOffsetMinutes: this.$store.getters.storeInfo.timeZoneUtcOffsetMin
            };
            padOrder = { items: [], timeZone: timeZone, total: 0 };
          }
          let orderTime = mUtils.toSQLDateTimeString(new Date());
          cachedOrder.orderItems.forEach(oi => {
            let orderItem = {
              ID: oi.ID,
              descr: oi.ord_descr,
              descr1: oi.ord_descr1,
              descr2: oi.descr2,
              discountRate: oi.discountRate,
              discountValue: oi.discountValue,
              extended: oi.extended,
              group: "A",
              orderTime: orderTime,
              qty: oi.qty,
              type: "I"
            };
            padOrder.items.push(orderItem);

          });
          padOrder.total += cachedOrder.total;

          this.$store.commit("PAD_ORDER", padOrder);

          console.log("padOrder", padOrder);
        }
      }
      this.refreshing = false;
    },

    async updateOrderQty(oi, adjQty) {
      if (!oi || isNaN(adjQty) || isNaN(oi.qty)) return;
      if (oi.qty + adjQty < 0) return;

      oi.qty += adjQty;
      oi.extended = this.$store.getters.orderItemExtended(oi);
    },

    getItemDescr(oi) {
      if (!oi) return "";
      if (this.$store.state.descrIndex == 1 && oi.descr1) return oi.descr1;
      else if (this.$store.state.descrIndex == 2 && oi.descr2) return oi.descr2;
      else return oi.descr;
    },

    getItemOptions(oi) {
      if (!oi) return "";

      let optionsDescr = "";
      oi.options.forEach(x => {
        x.items.forEach(y => {
          if (y.qty > 0) {
            let optDescr = "";
            if (this.$store.state.descrIndex == 1 && y.descr1) optDescr = y.descr1;
            else if (this.$store.state.descrIndex == 2 && y.descr2) optDescr = y.descr2;
            else optDescr = y.descr;

            if (optDescr) {
              optionsDescr += (optionsDescr == "" ? "" : ", ") + (y.qty > 1 ? y.qty + "x" : "") + optDescr;
            }
          }
        });
      });

      /*
      oi.options.forEach(x => {
        x.ordered.forEach(y => {
          let opt = y.option;
          if (opt) {
            let optDescr = "";
            if (this.$store.state.descrIndex == 1 && opt.descr1) optDescr = opt.descr1;
            else if (this.$store.state.descrIndex == 2 && oi.descr2) optDescr = opt.descr2;
            else optDescr = opt.descr;

            if (optDescr) {
              optionsDescr += (optionsDescr == "" ? "" : ", ") + (opt.qty > 1 ? opt.qty + "x" : "") + optDescr;
            }
          }
        });
      });
      */

      return optionsDescr;
    },
  },
};
</script>

<style lang="scss">
.cart-dialog {
  height: 90vh !important;
  width: 80vw !important;

  .d-container {
    background-color: white;

    height: 100%;
    width: 100%;

    position: relative;
    overflow: hidden;

    .d-close-button {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;

      color: var(--v-primary-base);
      font-size: 2.4em;
    }

    .d-background {
      position: absolute;
    }

    .result-panel {
      height: 100%;
      position: relative;

      .result-message {
        position: absolute;
        top: 300px;
        left: 100px;
      }
    }

    .review-panel {
      height: 100%;
      position: relative;

      .header {
        padding: 16px;
        height: 80px !important;

        display: flex;
        justify-content: center;

        .header-title {
          color: var(--v-primary-base);
          text-align: center;
          font-size: 2.5em;
          line-height: normal;
        }
      }

      .ordered-items {
        height: calc(100% - 80px - 100px);
        overflow: scroll !important;
        padding: 0px 64px;
        position: relative;

        .ordered-item {
          .item-image {
            border-radius: 15px;
          }

          .item-descr {
            font-size: 1.5em;
            font-weight: bolder;

            .item-options {
              font-size: 0.8em;
            }
          }

          .item-total {
            font-size: 1.75em;
          }

          .qty-col {
            display: flex;
            justify-content: center;
            align-items: center;

            .qty-box {
              display: flex;
              align-items: center;

              height: 50px;
              background-color: rgba(255, 255, 255, 0.75);
              display: flex;
              align-items: center;
              height: 50px;
              border-radius: 25px;
              background-color: rgba(255, 255, 255, 0.75);
              padding: 12px;

              .qty-value {
                min-width: 80px;
                text-align: center;
              }
            }
          }
        }
      }

      .footer {
        height: 100px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .v-btn {
          font-size: 1em;
          width: 240px;
        }
      }
    }
  }
}
</style>
